import { render, staticRenderFns } from "./HsabAdvancedNav.vue?vue&type=template&id=056f4b4e&scoped=true"
import script from "./HsabAdvancedNav.vue?vue&type=script&lang=ts"
export * from "./HsabAdvancedNav.vue?vue&type=script&lang=ts"
import style0 from "./HsabAdvancedNav.vue?vue&type=style&index=0&id=056f4b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f4b4e",
  null
  
)

export default component.exports